import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import AlertBox from 'components/ui/AlertBox';
import { bookingShape } from 'constants/propTypes';
import OutboundJourneySearchDate from 'components/shared/JourneySearchDate/OutboundJourneySearchDate';
import InboundJourneySearchDate from 'components/shared/JourneySearchDate/InboundJourneySearchDate';
import { MobileDatePickerHeader, MobileJourneyInfo, BoldText } from './JourneySearchTables.styles';

const MobileJourneySection = ({
  direction,
  date,
  journeyInfo,
  booking,
  outboundDate,
  inboundDate,
  cheapestFares,
  currency,
  subscriptionStartDate,
  subscriptionEndDate,
  isExchangingSingleLegOfSNCBSummated,
  swapStations,
  shouldForce,
  totalJourneys,
  filteredJourneys
}) => {
  const isOutbound = direction === 'outbound';
  const DatePickerComponent = isOutbound ? OutboundJourneySearchDate : InboundJourneySearchDate;

  const formattedDate = moment(date, 'YYYY-MM-DD').format('dddd D MMMM YYYY');
  const separator = '-';
  const fromStation = swapStations ? journeyInfo?.destination : journeyInfo?.origin;
  const toStation = swapStations ? journeyInfo?.origin : journeyInfo?.destination;

  return (
    <>
      <MobileDatePickerHeader>
        <DatePickerComponent
          booking={isOutbound && inboundDate ? null : booking}
          isReturnJourney={!!outboundDate && !!inboundDate}
          cheapestFares={cheapestFares}
          currency={currency}
          subscriptionStartDate={subscriptionStartDate}
          subscriptionEndDate={subscriptionEndDate}
          leg={booking?.[direction]}
          isExchangingSingleLegOfSNCBSummated={isExchangingSingleLegOfSNCBSummated}
          testIdSuffix="-mobile"
        />
        <MobileJourneyInfo id={`${direction}-table-header-mobile`}>
          <BoldText>
            <FormattedMessage id={`searchResults.${direction}.on`} />
          </BoldText>
          {` ${formattedDate} ${separator} ${fromStation} `}
          <BoldText>
            <FormattedMessage id="searchResults.to" />
          </BoldText>
          {` ${toStation}${isOutbound ? ' ' : ''}`}
        </MobileJourneyInfo>
      </MobileDatePickerHeader>
      {shouldForce && totalJourneys > filteredJourneys && (
        <AlertBox variant={AlertBox.variants.WARNING}>
          <FormattedMessage id="exchange.forceDirect" />
        </AlertBox>
      )}
    </>
  );
};

MobileJourneySection.propTypes = {
  direction: PropTypes.oneOf(['outbound', 'inbound']).isRequired,
  date: PropTypes.string.isRequired,
  journeyInfo: PropTypes.shape({
    origin: PropTypes.string,
    destination: PropTypes.string,
    originUIC: PropTypes.string,
    destinationUIC: PropTypes.string
  }).isRequired,
  booking: bookingShape,
  outboundDate: PropTypes.string,
  inboundDate: PropTypes.string,
  cheapestFares: PropTypes.shape({
    cheapestFares: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        price: PropTypes.number
      })
    )
  }),
  currency: PropTypes.string,
  subscriptionStartDate: PropTypes.string,
  subscriptionEndDate: PropTypes.string,
  isExchangingSingleLegOfSNCBSummated: PropTypes.bool,
  swapStations: PropTypes.bool,
  shouldForce: PropTypes.bool,
  totalJourneys: PropTypes.number,
  filteredJourneys: PropTypes.number
};

export default MobileJourneySection;
